import { Component, Inject, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { UserRepo } from 'src/app/repositories/user-repo';
import { User } from 'src/swagger-gen/web-secured/models';

@Component({
    selector: 'app-modal-delete-user',
    templateUrl: './modal-delete-user.component.html',
    styleUrls: ['./modal-delete-user.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ModalDeleteUserComponent implements OnDestroy {
  loading = false;
  deleteSuccess: any;
  deleteError: any;
  constructor(
    @Inject(MAT_DIALOG_DATA) public user: User,
    private userRepo: UserRepo,
    private translate: TranslateService,
    private router: Router
  ) {}

  deleteUser() {
    this.loading = true;
    this.userRepo
      .deleteUser(this.user.uid).toPromise()
        .then((response: any) => {
          this.loading = false;
          this.deleteSuccess = this.translate.instant('users.delete.success');
        })
        .catch((error: any) => {
          this.loading = false;
          this.deleteError = this.translate.instant('users.delete.error');
        });
  }

  ngOnDestroy() {
  }
}
